import App from "./App.vue";
import Vconsole from "vconsole";
import Vue from "vue";
import VueDragResize from "vue-drag-resize";
import { Toast, Popup, Loading, Checkbox } from "vant";

if (/localhost|^192|^172|-dev|-stg|-pre/.test(location.hostname)) {
  new Vconsole();
}

Vue.config.productionTip = false;

Vue.use(Toast);
Vue.use(Loading);
Vue.use(Checkbox);
Vue.component(Popup.name, Popup);
Vue.prototype.$toast = Toast;
Vue.component("vue-drag-resize", VueDragResize);

new Vue({
  render: h => h(App)
}).$mount("#app");
